import { TooltipLabel } from '@eluve/blocks';
import {
  HStack,
  Icon,
  LinkButton,
  VStack,
  legacyTextStyles,
} from '@eluve/components';
import { formatDate } from '@eluve/date-utils';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

import { AppointmentEmailSuperbillDialog } from './AppointmentEmailSuperbillDialog';

type SuperbillCardProps = {
  createdAt: string;
  downloadUrl: string;
};

export const SuperbillCard = ({
  createdAt,
  downloadUrl,
}: SuperbillCardProps) => {
  return (
    <HStack gap={4}>
      <VStack
        className="size-11 shrink-0 rounded-lg bg-border-primary"
        align="center"
        justify="center"
      >
        <Icon name="FileText" size="sm" />
      </VStack>
      <VStack gap={0}>
        <span
          className={legacyTextStyles.body({ size: 'm', weight: 'semibold' })}
        >
          Superbill
        </span>
        <span
          className={legacyTextStyles.body({ color: 'secondary', size: 's' })}
        >
          {formatDate.toDisplay(createdAt)}
        </span>
      </VStack>
      <HStack justify="end">
        <FeatureFlaggedComponent flag="ENABLE_SUPERBILL_EMAIL">
          <AppointmentEmailSuperbillDialog />
        </FeatureFlaggedComponent>
        <TooltipLabel
          tooltipContentProps={{ align: 'end', alignOffset: -8 }}
          label="View PDF"
        >
          <LinkButton
            href={downloadUrl}
            icon={{ name: 'Eye' }}
            size="s"
            type="outlineSubtle"
          />
        </TooltipLabel>
      </HStack>
    </HStack>
  );
};
